export function getRightFirstTimePercent(totalChecked, totalEverRejected) {
  if (!totalChecked) return null;
  const passedFirstTime = totalChecked - totalEverRejected;
  const ratio = Math.max(0, passedFirstTime) / totalChecked;
  return ratio * 100;
}

export function formatPercent(value) {
  return value == null ? '—' : `${value.toFixed(1)}%`;
}

export const PRODUCT_TYPE_LABELS = {
  FRAME: 'Frame (N & C combined)',
  ANCILL: 'Ancillary Boxes',
  HARDWARE: 'Hardware Boxes',
  WELDED: 'Welded Cills'
};

export function mapCheckedGroups(groups) {
  return (groups || []).map(g => ({
    key: g.productType,
    label: PRODUCT_TYPE_LABELS[g.productType] || g.productType,
    totalToCheck: g.totalToCheck,
    totalChecked: g.totalChecked,
    totalRejected: g.totalRejected
  }));
}

// Adapts `GET v1/prod-quality/remakes-checked` response `groups[]`. Per group:
// `totalRemake` = remake jobs for that category today, `totalChecked` = how many
// of those remakes were QC-checked, `totalRejected` = how many were rejected.
export function mapRemakeGroups(groups) {
  return (groups || []).map(g => ({
    key: g.productType,
    label: PRODUCT_TYPE_LABELS[g.productType] || g.productType,
    totalRemake: g.totalRemake,
    totalChecked: g.totalChecked,
    totalRejected: g.totalRejected
  }));
}
